<div class="card-header bg-success">
    <div class="row">
        <div class="col-md-6">
            <h3 class="text-white">Quote: {{(quoteDetails)?quoteDetails.quote_ref_number:''}}
                <!-- <span
                    class="badge badge-danger text-white text-capitalize">{{(quoteDetails)?quoteDetails.status:''}}</span> -->
            </h3>
        </div>
        <div class="col-md-6 text-right" *ngIf="quoteDetails">
            <span *ngIf="!isBroker">
                <!-- <button (click)="markAsReferred(referQuoteModal)" class="btn btn-dark btn-sm mr-2">Manual Refer</button> -->
            </span>
            <span
                *ngIf="quoteDetails.status != 'referred' && quoteDetails.status != 'issued' && quoteDetails.status != 'declined'">
                <a [routerLink]="['/sdtk/quote', id]" class="btn btn-danger btn-sm">Edit</a>
            </span>
            <span
                *ngIf="quoteDetails.insurance_status_id == '80c0db90-ba5d-4387-b09a-4c008a664932' && !hideForBroker">
                <button (click)="issueQuotePopup(issueQuoteModal)" class="btn btn-dark btn-sm ml-2">Convert to Policy and Issue Cover</button>
            </span>
        </div>
    </div>
</div>
<mat-tab-group class="float-left w-100" [(selectedIndex)]="selectedIndex">
    <mat-tab>
        <ng-template mat-tab-label>
            Overview
        </ng-template>
        <div class="card-body">
            <app-sdtk-overview [quoteDetails]="quoteDetails"></app-sdtk-overview>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            Full Details
        </ng-template>
        <div class="card-body">
            <app-sdtk-full-details [quoteDetails]="quoteDetails"></app-sdtk-full-details>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            Financials
        </ng-template>
        <div class="card-body">
            <app-sdtk-financials [quoteDetails]="quoteDetails"></app-sdtk-financials>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            Documents
        </ng-template>
        <div class="card-body">
            <app-sdtk-documents [quote]="quoteDetails"></app-sdtk-documents>
        </div>
    </mat-tab>
    <!-- <mat-tab *ngIf="isAdmin">
        <ng-template mat-tab-label>
            Email
        </ng-template>
        <div class="card-body">
            <app-quote-email (emailView)="getEmailView($event)" (newEmailView)="newEmailView()" [quote]="quoteDetails"
                *ngIf="!displayEmailView && !displayNewEmailView"></app-quote-email>
            <app-quote-email-view (backToEmailsList)="backToEmailsList()" [email_id]="email_id"
                *ngIf="displayEmailView"></app-quote-email-view>
            <app-quote-email-compose (backToEmailsList)="backToEmailsList()" [quote]="quoteDetails"
                *ngIf="displayNewEmailView"></app-quote-email-compose>
        </div>
    </mat-tab> -->
</mat-tab-group>
<ng-template #issueQuoteModal let-modal>
    <div class="modal-body">
        <div *ngIf="disablIfPastDate" class="alert alert-danger">
            The policy start date is in the past. Please edit the quote and update the start date before placing on cover.
        </div>
        <p *ngIf="!disablIfPastDate">Do you want to issue the quote?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-sm" (click)="modal.close()">{{ disablIfPastDate ? 'Close' : 'No' }}</button>
        <button *ngIf="!disablIfPastDate" type="button" class="btn btn-success btn-sm" (click)="issueQuote()">Yes</button>
    </div>
</ng-template>